export default "__VITE_ASSET__snl$_TN8__";